module.exports = __webpack_public_path__ + "static/media/corporate-services-img75.bfad5c2d.jpg";